(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-cc-warning.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-cc-warning.js');

'use strict';

const Paper = svs.ui.ReactPaper;
const Icon = svs.ui.ReactIcon;
const DepositCcWarning = () => React.createElement(Paper, {
  branding: "tur",
  className: "padding-1 deposit-cc-warning margin-bottom-2 margin-top-2",
  isFlat: true
}, React.createElement("div", {
  className: "u-flex"
}, React.createElement("div", {
  className: "margin-right-1"
}, React.createElement(Icon, {
  icon: "creditcard",
  size: "300"
})), React.createElement("div", null, "Fr\xE5n och med 30 april g\xE5r det inte l\xE4ngre att anv\xE4nda kreditkort f\xF6r ins\xE4ttning till spelkontot.")));
svs.accountservicesReact.deposit.depositShared.DepositCcWarning = DepositCcWarning;

 })(window);